import Vue from 'vue';

export default {

    async create_checkout (subdomain, account_id, email, cus_id, plan, success_url, cancel_url) {


        return await fetch(Vue.prototype.$apiBase+'/account/create-checkout', {
            method: 'post',
            headers: {
            'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                subdomain: subdomain,
                account_id: account_id, 
                cus_id: cus_id, 
                email: email, 
                plan: plan, 
                success_url: success_url, 
                cancel_url: cancel_url
            }),
            })
            .then((response) => {
            return response.json();
            })
            .then((response) => {
            return response
        });   

    },


  async get_next_invoice (subdomain, cus_id) { 

    console.log("--- ", Vue.prototype.$apiBase+'/stripe/next-invoice?subdomain='+subdomain+'&cus_id='+cus_id)
    return await fetch(Vue.prototype.$apiBase+'/stripe/next-invoice?subdomain='+subdomain+'&cus_id='+cus_id, {
        method: 'get',
        headers: {
        'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        return response
    });   

  },

  async cancel_subscription (subdomain, cus_id) {

    return await fetch(Vue.prototype.$apiBase+'/stripe/cancel-subscription?subdomain='+subdomain+'&cus_id='+cus_id, {
        method: 'get',
        headers: { 
        'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        return response
    });   

  },

  async delete_subscription (subdomain, cus_id) {

    return await fetch(Vue.prototype.$apiBase+'/stripe/delete-subscription?subdomain='+subdomain+'&cus_id='+cus_id, {
        method: 'get',
        headers: { 
        'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        return response
    });   

  },

  async list_invoices (subdomain, cus_id) {

    return await fetch(Vue.prototype.$apiBase+'/stripe/list-invoices?subdomain='+subdomain+'&cus_id='+cus_id, {
        method: 'get',
        headers: { 
        'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        return response
    });   

  },
  
}
